module.exports = __webpack_public_path__ + "static/media/about-us-3.d4304cb3.jpg";